<label [class.flex-middle]="alignCenter">
    <ng-content />
</label>